"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AddClassDefinitionDialogModule = /** @class */ (function () {
    function AddClassDefinitionDialogModule() {
    }
    return AddClassDefinitionDialogModule;
}());
exports.AddClassDefinitionDialogModule = AddClassDefinitionDialogModule;
